import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/phred/pages/CalculatorPage";

export const Route = createFileRoute("/phred-quality-score")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/phred-quality-score",
      title: m.phred_meta_title(),
      description: m.phred_meta_description(),
      toolName: m.phred_tool_name(),
      faqs: [
        { q: m.phred_faq_q1(), a: m.phred_faq_a1() },
        { q: m.phred_faq_q2(), a: m.phred_faq_a2() },
        { q: m.phred_faq_q3(), a: m.phred_faq_a3() },
        { q: m.phred_faq_q4(), a: m.phred_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
